import { styled, Stack } from '@mui/material';

export const PADDING = '0 14vw';

export const MOBILE_PADDING = '0 4vw';

export const ChatPageContainer = styled(Stack)({
  height: '100%',
  width: '100%'
});

export const ChatResponseContainer = styled(Stack)({
  width: '100%',
  height: 'calc(100% - 70px)'
});

export const ChatInputContainer = styled(Stack)({
  padding: PADDING
});

export const SuggestionsContainer = styled(Stack)({
  width: '100%',
  height: '100%',
  '.suggestions-container': {
    padding: '0',
    width: '100%'
  }
});
